module.exports = __webpack_public_path__ + "static/media/bhaskar_pardeshi.6a80783d.jpg";